import React from "react";
import MenuBadge from "../../../DesktopMenu/DesktopMenuDrawers/MenuBadge";
import { getNutritionalProducts, getVitaminsProducts } from "../../../helpers";
import * as S from "../../styles";

var NutritionalSubMenu = function NutritionalSubMenu(_ref) {
  var e = _ref.combinedProducts,
      t = _ref.category,
      a = _ref.cards,
      n = _ref.handleLinkClick,
      i = _ref.handleFilteredPipLinkClick,
      l = _ref.renderLinkAs,
      r = _ref.filteredPipLink;
  var c = getNutritionalProducts(e),
      o = getVitaminsProducts(e);
  return React.createElement(React.Fragment, null, React.createElement(S.AccordionItem, {
    key: t.slug
  }, React.createElement(S.AccordionHeading, {
    dataTestId: "mobile-shop-category-" + t.slug,
    onClick: function onClick() {
      return n(t.displayName);
    }
  }, React.createElement(S.AccordionHeadingContainer, null, React.createElement("span", null, t.displayName), React.createElement(MenuBadge, {
    iconText: "NEW"
  }))), React.createElement(S.AccordionChildSubHeader, {
    isFirstSubHeader: !0,
    dataTestId: "nutritional-tests-mobile-links"
  }, React.createElement(S.AccordionHeadingContainer, null, "Tests")), c.map(function (_ref2, c) {
    var e = _ref2.label,
        a = _ref2.url,
        i = _ref2.slug,
        r = _ref2.badge;
    return React.createElement(S.NutritionAccordionChild, {
      key: "mobile-".concat(i, "-").concat(c)
    }, React.createElement(S.MenuItem, {
      "data-testid": i,
      onClick: function onClick() {
        return n("".concat(t.displayName, " - ").concat(e));
      },
      href: a,
      as: l || void 0
    }, e, r ? React.createElement(MenuBadge, {
      iconText: r
    }) : null));
  }), React.createElement(S.AccordionChildSubHeader, {
    dataTestId: "nutritional-vitamins-mobile-links"
  }, React.createElement(S.AccordionHeadingContainer, null, "Vitamins & Supplements")), o.map(function (_ref3, r) {
    var e = _ref3.label,
        a = _ref3.url,
        i = _ref3.slug;
    return React.createElement(S.NutritionAccordionChild, {
      key: "mobile-".concat(i, "-").concat(r)
    }, React.createElement(S.MenuItem, {
      "data-testid": i,
      onClick: function onClick() {
        return n("".concat(t.displayName, " - ").concat(e));
      },
      href: a,
      as: l || void 0
    }, e));
  }), React.createElement(S.ShopAllFilteredPipAccordionChild, null, React.createElement(S.ShopAllFilteredPipButton, {
    href: r.url,
    onClick: function onClick() {
      return i(r);
    }
  }, "Shop all " + r.categoryName)), React.createElement(S.PromoCardsAccordionChild, {
    dataTestId: "nutritional-mobile-cards"
  }, a.map(function (e) {
    return React.createElement(S.ProductCard, Object.assign({
      key: e.slug,
      testIDPrefix: "cards"
    }, e));
  }))));
};

export default NutritionalSubMenu;